import { ShieldAlert } from 'lucide-react';
import React from 'react';

export const SecurityAccessDenied: React.FC = () => (
  <div className="flex items-center justify-center py-16">
    <div className="max-w-md rounded-2xl border border-amber-200 bg-amber-50 px-6 py-8 text-center">
      <ShieldAlert className="mx-auto mb-4 text-amber-600" size={40} />
      <h2 className="text-lg font-semibold text-black">Access restricted</h2>
      <p className="mt-2 text-sm leading-6 text-gray-700">
        Only super and super admin users can manage access controls and security
        policies.
      </p>
    </div>
  </div>
);
